import { createContext, useContext } from 'react';

type PavilionContextType = {
  isPavilionMode: boolean;
};

export const PavilionContext = createContext<PavilionContextType | undefined>(undefined);

export function usePavilion() {
  const context = useContext(PavilionContext);
  if (context === undefined) {
    throw new Error('usePavilion must be used within a PavilionProvider');
  }
  return context;
}
